module.exports = __webpack_public_path__ + "./img/calculator_notallowed_scaled.svg";